export * from './chat-store.module';
export * from './state';
export * from './actions';
export * from './reducer';
export * from './effects';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChatState } from './state';

export const selectChatState = createFeatureSelector<ChatState>('chat');

export const selectChatBoxVisibility = createSelector(
  selectChatState,
  (state: ChatState) => state.showChatBox
); 